<template>
    <div class="login container">
        <form @submit.prevent="login" class="card-panel">
            <h2 class="deep-purple-text center-align">Login</h2>
            <div class="field">
                <label for="email">Your email:</label>
                <input type="email" name="email" v-model="email">
            </div>
            <div class="field">
                <label for="password">Your password:</label>
                <input type="password" name="password" v-model="password">
            </div>
            <p v-if="feedback" class="red-text center-align">{{ feedback }}</p>
            <div class="field center-align">
                <button class="btn deep-purple">Login</button>
            </div>
        </form>
    </div>
</template>

<script>
import firebase from 'firebase'
export default {
    name: 'Login',
    data() {
        return {
            feedback: null,
            email: null,
            password: null
        }
    },
    methods: {
        login() {
            if(this.email && this.password) {
                this.feedback = null
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cred => {
                    this.$router.push({name: 'GMap'})
                })
                .catch(error => {
                    this.feedback = error.message
                })
                
            } else {
                this.feedback = "You must enter both the fields."
            }
        }
    }
}
</script>

<style>
    .login .field {
        margin-bottom: 1%;
    }

    .login h2 {
        font-size: 2.4em;
    }

    .login {
        max-width: 50vw;
        margin-top: 2%;
    }

    .login input:focus {
        border-color: #673AB7 !important;
    }

    @media screen and (max-width: 768px) {
        .login {
            max-width: 100vw;
        }

        .login .card-panel {
            box-shadow: none;
            padding: 0px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue